
import { useState } from "react";
import { db } from "./Firebase";
import { collection, addDoc } from "firebase/firestore";
import { Link } from "react-router-dom";

export default function Register() {
    const [errorMessage, setErrorMessage] = useState("");

    async function submit(event) {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const name = data.get("name");
        const email = data.get("email");
        const contact = data.get("contact");
        const gender = data.get("gender");
        const password = data.get("password");
        const dateofbirth = data.get("dateofbirth");
        const address = data.get("address");

        try {
            await addDoc(collection(db, "Users"), {
                Name: name,
                Email: email,
                Contact: contact,
                Gender: gender,
                Password: password,
                Dateofbirth: dateofbirth,
                Address: address,
            });

            event.target.reset();
            setErrorMessage("");
            alert("🎉 Registration Successful!");
        } catch (error) {
            console.error("Registration Error:", error);
            setErrorMessage("❌ Registration failed. Please try again.");
        }
    }

    return (
        <>
            <div className="reg-container">
                <h1 className="reg-title">🚀 Register Now</h1>

                <div className="reg-card">
                    {errorMessage && <div className="reg-error">{errorMessage}</div>}

                    <form onSubmit={submit}>
                        <input
                            type="text"
                            name="name"
                            placeholder="👤 Name"
                            className="reg-input"
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="📧 E-mail"
                            className="reg-input"
                            required
                        />
                        <input
                            type="number"
                            name="contact"
                            placeholder="📞 Contact"
                            className="reg-input"
                            required
                        />
                        <select name="gender" className="reg-input" required>
                            <option value="">⚥ Select Gender</option>
                            <option>Male</option>
                            <option>Female</option>
                            <option>Others</option>
                        </select>
                        <input
                            type="password"
                            name="password"
                            placeholder="🔒 Password"
                            className="reg-input"
                            required
                        />
                        <input
                            type="date"
                            name="dateofbirth"
                            className="reg-input"
                            required
                        />
                        <input
                            type="text"
                            name="address"
                            placeholder="🏠 Address"
                            className="reg-input"
                            required
                        />
                        <button type="submit" className="reg-button">Register</button>

                        <p className="reg-link-text">
                            Existing customer? Click <Link to="/" className="reg-link">Here</Link>
                        </p>
                    </form>
                </div>
            </div>

            <style jsx>{`
                .reg-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100vh;
                    background-color: #f4f7fb;
                    padding: 20px;
                }

                .reg-title {
                    font-size: 36px;
                    color: #4e73df;
                    text-align: center;
                    margin-bottom: 30px;
                }

                .reg-card {
                    width: 100%;
                    max-width: 400px;
                    background-color: white;
                    padding: 30px;
                    border-radius: 10px;
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    text-align: center;
                }

                .reg-input {
                    width: 100%;
                    padding: 12px;
                    margin: 10px 0;
                    border-radius: 6px;
                    border: 1px solid #ddd;
                    font-size: 16px;
                    box-sizing: border-box;
                }

                .reg-input:focus {
                    border-color: #4e73df;
                    outline: none;
                }

                .reg-button {
                    width: 100%;
                    padding: 14px;
                    background-color: #4e73df;
                    border: none;
                    border-radius: 6px;
                    color: white;
                    font-size: 18px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                }

                .reg-button:hover {
                    background-color: #2e59d9;
                }

                .reg-error {
                    color: red;
                    font-size: 14px;
                    margin-bottom: 15px;
                }

                .reg-link-text {
                    font-size: 14px;
                    margin-top: 20px;
                }

                .reg-link {
                    color: #4e73df;
                    text-decoration: none;
                }

                .reg-link:hover {
                    text-decoration: underline;
                }
            `}</style>
        </>
    );
}
